(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class CpsHeaderSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('.cps-hsearch__input');
      this.panel = this.querySelector('.cps-hsearch__panel');
      this.clearBtn = this.querySelector('.cps-hsearch__clear');
      this.live = this.dataset.live === 'true';
      this.limit = parseInt(this.dataset.limit, 10) || 5;
      this.timer = null;
      this.ctrl = null;

      this.input.addEventListener('input', () => {
        this.clearBtn.hidden = !this.input.value;
        if (!this.live) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(), 220);
      });
      this.input.addEventListener('focus', () => {
        if (this.skipOpen) { this.skipOpen = false; return; }
        if (this.live && this.input.value.trim().length > 1 && this.panel.innerHTML) this.open();
      });
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.panel.addEventListener('keydown', (e) => this.onKey(e));
      this.clearBtn.hidden = !this.input.value;
      this.clearBtn.addEventListener('click', () => {
        this.input.value = '';
        this.clearBtn.hidden = true;
        this.close();
        this.input.focus();
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.close(); });
    }

    open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    close() { this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }

    onKey(e) {
      if (e.key === 'Escape') { this.close(); this.skipOpen = document.activeElement !== this.input; this.input.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (this.panel.hidden) return;
      const items = Array.from(this.panel.querySelectorAll('a'));
      if (!items.length) return;
      e.preventDefault();
      const i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') items[Math.min(i + 1, items.length - 1)].focus();
      else if (i <= 0) this.input.focus();
      else items[i - 1].focus();
    }

    esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    money(v) {
      const n = parseFloat(v);
      if (isNaN(n)) return this.esc(v);
      try {
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(n);
      } catch (err) { return n.toFixed(2); }
    }

    thumb(u) {
      if (!u) return '';
      try { const url = new URL(u, location.origin); url.searchParams.set('width', '120'); return url.toString(); } catch (err) { return u; }
    }

    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.close(); this.panel.innerHTML = ''; return; }
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=' + this.limit +
        '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      try {
        const res = await fetch(url, { signal: this.ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        this.render(q, data.resources && data.resources.results ? data.resources.results : {});
      } catch (err) {
        if (err.name !== 'AbortError') this.close();
      }
    }

    render(q, r) {
      const cols = r.collections || [];
      const prods = r.products || [];
      const d = this.dataset;
      const allUrl = this.form.action + (this.form.action.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      let h = '';
      if (!cols.length && !prods.length) {
        h = '<p class="cps-hsearch__empty">' + this.esc(d.emptyLabel || 'No results for') + ' &ldquo;' + this.esc(q) + '&rdquo;</p>';
      } else {
        if (cols.length) {
          h += '<p class="cps-hsearch__label">' + this.esc(d.catsLabel || 'Categories') + '</p><div class="cps-hsearch__chips">' +
            cols.map((c) => '<a class="cps-hsearch__chip" href="' + this.esc(c.url) + '">' + this.esc(c.title) + '</a>').join('') + '</div>';
        }
        if (prods.length) {
          h += '<p class="cps-hsearch__label">' + this.esc(d.prodsLabel || 'Products') + '</p><ul class="cps-hsearch__list">' +
            prods.map((p) => {
              const img = this.thumb((p.featured_image && p.featured_image.url) || p.image);
              return '<li><a class="cps-hsearch__item" href="' + this.esc(p.url) + '">' +
                (img ? '<img class="cps-hsearch__thumb" src="' + this.esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="cps-hsearch__thumb"></span>') +
                '<span class="cps-hsearch__meta"><span class="cps-hsearch__name">' + this.esc(p.title) + '</span>' +
                (p.vendor ? '<span class="cps-hsearch__vendor">' + this.esc(p.vendor) + '</span>' : '') + '</span>' +
                '<span class="cps-hsearch__price">' + this.money(p.price) + '</span></a></li>';
            }).join('') + '</ul>';
        }
        h += '<a class="cps-hsearch__all" href="' + this.esc(allUrl) + '">' + this.esc(d.allLabel || 'See all results') + ' &ldquo;' + this.esc(q) + '&rdquo; &rarr;</a>';
      }
      this.panel.innerHTML = h;
      this.open();
    }
  }

  if (!customElements.get('cps-header-search')) customElements.define('cps-header-search', CpsHeaderSearch);

  } catch(e) { console.error(e); }
})();
})();
